import React, { PureComponent, Fragment } from 'react';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Link } from 'formlabs-web-components/Link';

import TertiaryMenu from './TertiaryMenu';

import './HeaderMenu.module.css';
import { withTranslation } from 'react-i18next';

class Dropdown extends PureComponent {
  state = {
    selected: 0
  };
  child = React.createRef();

  menuClose = () => {
    this.props.handleHoverMenuClose();
    this.hoverSubMenu(0);
  };

  hoverSubMenu = selected => {
    this.setState({ selected });
  };

  render() {
    const { hoverOptions, dropdownOpen, data, t } = this.props;
    const { selected } = this.state;
    return (
      <Fragment>
        {data[hoverOptions].children.length >= 1 && (
          <Fragment>
            <nav
              styleName={`dropdown description-dropdown open-${dropdownOpen}`}
              aria-label={t('Show dropdown menu')}
            >
              <div styleName="top-grey-border">
                <Grid direction="x">
                  <Cell mediumSize={11}>
                    <div styleName="content-left">
                      <Grid direction="x">
                        <Cell
                          mediumSize={10}
                          secondaryAlignment="align-self-top"
                        >
                          <div styleName="description-secondary fade-img fade-0">
                            {data[hoverOptions].children.map((child, i) => {
                              return (
                                <Link
                                  to={child.url}
                                  openInNewWindow={child.newWindow}
                                  styleName={`dropdown-left ${
                                    selected === i ? 'selected-secondary' : ''
                                  }`}
                                  key={i}
                                  onMouseEnter={() => this.hoverSubMenu(i)}
                                >
                                  <div>
                                    <span>{child.name} </span>
                                    <span>
                                      <i className="fl-navigate_next" />
                                    </span>
                                  </div>
                                </Link>
                              );
                            })}
                          </div>
                        </Cell>
                        <Cell mediumSize={2}>
                          <div styleName="menu-divide fade-img fade-0" />
                        </Cell>
                        <Cell
                          mediumSize={8}
                          mediumOffset={1}
                          secondaryAlignment="align-self-top"
                        >
                          <div styleName="description-secondary  fade-img fade-1">
                            {data[hoverOptions].children[selected].children && (
                              <TertiaryMenu
                                ref={this.child}
                                items={
                                  data[hoverOptions].children[selected].children
                                }
                              />
                            )}
                          </div>
                        </Cell>
                      </Grid>
                    </div>
                  </Cell>
                  <Cell mediumSize={12} mediumOffset={1}>
                    <div
                      styleName="menu-image  fade-2"
                      style={{
                        backgroundImage: `url(${
                          data[hoverOptions].children[selected].image
                        })`
                      }}
                    />
                  </Cell>
                </Grid>
              </div>
            </nav>
          </Fragment>
        )}
        {data[hoverOptions].children && (
          <Fragment>
            <div styleName={`dropdown open-${dropdownOpen}`} />
            <div
              styleName={`overlay overlay-clear open-false`}
              onMouseEnter={this.menuClose}
            />
          </Fragment>
        )}
        <div
          styleName={`overlay open-${dropdownOpen}`}
          onMouseEnter={this.menuClose}
        />
      </Fragment>
    );
  }
}
export default withTranslation()(Dropdown);
